import { render, staticRenderFns } from "./LoginV1.vue?vue&type=template&id=4a9376e2&"
import script from "./LoginV1.vue?vue&type=script&lang=js&"
export * from "./LoginV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports